export default __webpack_public_path__ + "static/media/img-4.0b410271.jpg";